import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { DEFAULT_PRIMARY_COLOUR } from 'shared/constants/styleConstants';

const tableHeaderStyle = ' text-gray-500 pb-3 font-normal';
const tableBodyStyle = 'py-3 border-b';

export default function PassengersTableLargeScreen({
  className = '',
  passengerList = [],
}) {
  const { whiteLabelSettings: { primaryColour, secondaryColour } = {} } =
    useWhiteLabelSettings();

  return (
    <table className={`${className} table-fixed w-full text-left break-words`}>
      <thead>
        <tr className="text-gray-500 border-b">
          <th className={`w-[10%] ${tableHeaderStyle}`}>Title</th>
          <th className={`w-[25%] ${tableHeaderStyle}`}>First name</th>
          <th className={`w-[25%] ${tableHeaderStyle}`}>Last name</th>
          <th className={`w-[15%] ${tableHeaderStyle}`}>Type</th>
        </tr>
      </thead>
      <tbody>
        {passengerList.map(({ id, title, firstName, lastName, type, lead }) => (
          <tr key={id}>
            <td className={tableBodyStyle}>{title}</td>
            <td className={tableBodyStyle}>{firstName}</td>
            <td className={tableBodyStyle}>{lastName}</td>
            <td className={`${tableBodyStyle} flex justify-between`}>
              <div>{type}</div>
              <div>
                {lead && (
                  <span
                    style={{
                      backgroundColor:
                        secondaryColour || DEFAULT_PRIMARY_COLOUR,
                      color: primaryColour || '#fff',
                    }}
                    className="ml-2 py-1 px-3 text-white text-xs font-medium rounded-[2px]"
                  >
                    LEAD
                  </span>
                )}
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
